import { render } from "./TowerEdit.vue?vue&type=template&id=6c038a3e&scoped=true"
import script from "./toweredit.js?vue&type=script&lang=js&external"
export * from "./toweredit.js?vue&type=script&lang=js&external"

import "./TowerEdit.vue?vue&type=style&index=0&id=6c038a3e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c038a3e"]])

export default __exports__